import { NotificationPreferenceDto } from '../../models/dtos/notification/notification-dtos';

// Match the server's NotificationPreferencePolicy: account channel, account type,
// club channel, club type. An absent override means notifications are enabled.
export function resolveNotificationPreference(
  preferences: readonly NotificationPreferenceDto[],
  clubId: string | null,
  notificationType: string | null,
  channel: number,
  excludeCurrent = false
): boolean {
  let enabled = true;
  let highestSpecificity = -1;

  for (const preference of preferences) {
    const preferenceClub = preference.clubId ?? null;
    const preferenceType = preference.notificationType ?? null;

    if (preference.channel !== channel || (preferenceClub && !sameId(preferenceClub, clubId)) ||
        (preferenceType && !sameId(preferenceType, notificationType))) {
      continue;
    }

    if (excludeCurrent && sameId(preferenceClub, clubId) && sameId(preferenceType, notificationType)) {
      continue;
    }

    const specificity = (preferenceClub ? 2 : 0) + (preferenceType ? 1 : 0);
    if (specificity > highestSpecificity) {
      highestSpecificity = specificity;
      enabled = preference.enabled;
    }
  }

  return enabled;
}

export function sameId(left: string | null, right: string | null): boolean {
  return left?.toLowerCase() === right?.toLowerCase();
}
